// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-e5349538","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/iview-loader?{"prefix":false}!./src/views/main_components/sidebarMenuShrink.vue
// module id = 1226
// module chunks = 61